import React from 'react';
import { AsyncAutosuggest } from 'components';

const CourseAutosuggest = ({ value, label, handleChange }) => (
	<AsyncAutosuggest
		name="course_id"
		label={label}
		value={value}
		displayField="title"
		remoteUrl="/api/v1/admin/courses"
		placeholder="Select"
		handleChange={handleChange}
	/>
);

export default CourseAutosuggest;
